/**
 * @Author: junfeng.liu
 * @Date: 2018-09-25 12:24:19
 * @LastEditors: junfeng.liu
 * @LastEditTime: 2018-09-25 12:24:19
 * @Description: ''
 */

export default {
    functional: true,
    props: {
        render: {
            type: Function
        },
        params: {},
        index: {}
    },
    render: (h, ctx) => {
        let index = ctx.props.index
        let params = {}
        if (index || index === 0) params.index = index
        if (ctx.props.params) params.params = ctx.props.params
        return ctx.props.render(h, params)
    }
}
